import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { confirmResetPassword } from '@aws-amplify/auth';
import { Form, Button, Alert } from 'react-bootstrap';
import './LoginPage.css';
import { normalizeLoginUsername } from '../utils/normalizeSignupPhone';

export function ResetPasswordPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const emailFromUrl = searchParams.get('email') || '';

  const [email, setEmail] = useState(emailFromUrl);
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (newPassword.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }

    setLoading(true);
    try {
      await confirmResetPassword({
        username: normalizeLoginUsername(email),
        confirmationCode: code,
        newPassword,
      });
      navigate('/');
    } catch (err) {
      setError(err.message || 'Failed to reset password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="tg-auth-card">
        <div className="tg-auth-brand">
          <div className="tg-auth-brand-mark">T</div>
          <span className="tg-auth-brand-name">Tegrat Auto</span>
        </div>

        <h2 className="tg-auth-title">Set new password</h2>
        <p className="tg-auth-subtitle">
          Enter the code sent to your email and choose a new password.
        </p>

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="email">
            <Form.Label>Email or signup phone number</Form.Label>
            <Form.Control
              type="text"
              name="username"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com or (555) 000-0000"
              disabled={loading}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="code">
            <Form.Label>Reset Code</Form.Label>
            <Form.Control
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="6-digit code"
              disabled={loading}
              required
              autoFocus={!!emailFromUrl}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="newPassword">
            <Form.Label>New Password</Form.Label>
            <Form.Control
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="At least 8 characters"
              disabled={loading}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="confirmPassword">
            <Form.Label>Confirm New Password</Form.Label>
            <Form.Control
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Re-enter new password"
              disabled={loading}
              required
            />
          </Form.Group>

          {error && <Alert variant="danger">{error}</Alert>}

          <div className="d-grid gap-2">
            <Button variant="primary" type="submit" disabled={loading} size="lg">
              {loading ? 'Resetting…' : 'Reset Password'}
            </Button>
          </div>
        </Form>

        <hr className="tg-auth-divider" />
        <div className="tg-auth-footer">
          <Link to="/forgot-password">Resend reset code</Link>
          <span className="tg-auth-dot">·</span>
          <Link to="/">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}

export default ResetPasswordPage;
